"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var tree_view_manager_1 = require("../service/tree-view-manager");
var FilterPathsPipe = /** @class */ (function () {
    function FilterPathsPipe() {
    }
    FilterPathsPipe.prototype.transform = function (paths, usedRowCategoryPathIds, node) {
        if (!paths) {
            return [];
        }
        var filteredPaths = paths;
        if (usedRowCategoryPathIds) {
            filteredPaths = paths.filter(function (pathDto) {
                var alreadyExistsInRows = usedRowCategoryPathIds.indexOf(pathDto.id) !== -1;
                // not include paths which already exist in rows.
                return !alreadyExistsInRows;
            });
        }
        if (!node) {
            return filteredPaths;
        }
        var branchElements = [];
        var branchPathIds = [];
        if (node.isSelected && !(node.isNew || node.isDefaultNew)) {
            var branchParentElements = tree_view_manager_1.TreeViewManager.fetchBranchNodes(node.parent);
            var branchParentPathIds = tree_view_manager_1.TreeViewManager.fetchBranchPathIds(node.parent);
            branchElements.push.apply(branchElements, branchParentElements);
            branchPathIds.push.apply(branchPathIds, branchParentPathIds);
            for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
                var child = _a[_i];
                var branchChildElements = tree_view_manager_1.TreeViewManager.fetchSubTreeNodes(child);
                var branchChildPathIds = tree_view_manager_1.TreeViewManager.fetchSubTreePathIds(child);
                branchElements.push.apply(branchElements, branchChildElements);
                branchPathIds.push.apply(branchPathIds, branchChildPathIds);
            }
        }
        else {
            var branchParentElements = tree_view_manager_1.TreeViewManager.fetchBranchNodes(node);
            var branchParentPathIds = tree_view_manager_1.TreeViewManager.fetchBranchPathIds(node);
            branchElements.push.apply(branchElements, branchParentElements);
            branchPathIds.push.apply(branchPathIds, branchParentPathIds);
        }
        var hasMeasureElement = branchElements.filter(function (columnView) { return columnView.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto; }).length > 0;
        var filter = filteredPaths.filter(function (pathDto) {
            var alreadyExists = branchPathIds.indexOf(pathDto.id) !== -1;
            var isMeasurePath = (pathDto instanceof idm_dataset_service_client_js_1.MeasurePathDto);
            // not include paths which already exist or if it's measure path and branch already contains measure path.
            return !(alreadyExists || (isMeasurePath && hasMeasureElement));
        });
        return filter;
    };
    FilterPathsPipe = __decorate([
        core_1.Pipe({
            name: 'filterPaths',
            pure: true
        }),
        __metadata("design:paramtypes", [])
    ], FilterPathsPipe);
    return FilterPathsPipe;
}());
exports.FilterPathsPipe = FilterPathsPipe;
//# sourceMappingURL=filter-paths.pipe.js.map